import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import TopNav from '../components/TopNav';

export default function Layout() {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  // Close the mobile drawer whenever the route changes
  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname]);

  // Escape key closes the drawer
  useEffect(() => {
    if (!navOpen) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setNavOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [navOpen]);

  // Lock body scroll while the drawer is open
  useEffect(() => {
    document.body.style.overflow = navOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [navOpen]);

  return (
    <div className="bg-background text-on-surface font-body antialiased min-h-screen">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      {navOpen && (
        <button
          type="button"
          aria-label="Close navigation"
          onClick={() => setNavOpen(false)}
          className="fixed inset-0 z-[55] bg-black/60 lg:hidden"
        />
      )}
      <TopNav onMenuClick={() => setNavOpen(true)} />
      <main className="pt-14 lg:pl-64 min-h-screen">
        <div className="mx-auto max-w-[1440px] p-4 sm:p-6 lg:p-8">
          <Outlet />
        </div>
      </main>
      <footer className="lg:pl-64 border-t border-outline-variant/20">
        <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8 py-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] text-on-surface-variant/70 font-body">
          <span className="material-symbols-outlined text-[14px] text-primary/70">sports_soccer</span>
          <span>English Football Pyramid</span>
          <span className="text-outline-variant">&bull;</span>
          <span>Steps 5&ndash;7</span>
          <span className="text-outline-variant">&bull;</span>
          <span>Non-League Goal Scorers</span>
        </div>
      </footer>
    </div>
  );
}
